module.exports = __webpack_public_path__ + "img/Section2Shape.d92c67f8.svg";